import _toConsumableArray from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import { SearchFilter } from '@/services/ResourceService';
import QueryService from '@/services/QueryService';
import { Bus as VuedalsBus } from 'vuedals';
import CreateSearchFilterModal from '@/components/shared/saved-search-filter/CreateSearchFilterModal';
export default {
  name: 'SearchFilterSelector',
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    preSelectedSearchFilterId: {
      type: Number,
      required: false,
      default: null
    },
    showFilterManagement: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      isInternallyLoading: true,
      isInternallyDisabled: false,
      searchFilters: null
    };
  },
  created: function created() {
    this.loadData();
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters({
    getLocationIdsByLocationGroupIds: 'general/getLocationIdsByLocationGroupIds'
  })), mapState({
    userId: function userId(state) {
      return state.general.selectedUser.id;
    }
  })), {}, {
    searchFiltersIsApplied: function searchFiltersIsApplied() {
      return !!this.preSelectedSearchFilterId;
    },
    dropdownButtonText: function dropdownButtonText() {
      var _this = this;
      var text = this.$t('selectSearchFilter');
      if (this.preSelectedSearchFilterId) {
        var _this$searchFilters, _this$searchFilters$f;
        var searchFilterName = (_this$searchFilters = this.searchFilters) === null || _this$searchFilters === void 0 ? void 0 : (_this$searchFilters$f = _this$searchFilters.find(function (sf) {
          return sf.id === _this.preSelectedSearchFilterId;
        })) === null || _this$searchFilters$f === void 0 ? void 0 : _this$searchFilters$f.name;
        text = searchFilterName || text;
      }
      return text;
    }
  }),
  methods: {
    loadData: function loadData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$SearchFilter$g, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.isInternallyLoading = true;
              _context.prev = 1;
              _context.next = 4;
              return SearchFilter.getAllSearchFiltersShort(_this2.userId);
            case 4:
              _yield$SearchFilter$g = _context.sent;
              data = _yield$SearchFilter$g.data;
              _this2.searchFilters = data;
              _context.next = 13;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              _this2.isInternallyDisabled = true;
              _this2.searchFilters = null;
            case 13:
              _this2.isInternallyLoading = false;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 9]]);
      }))();
    },
    onFilterSelected: function onFilterSelected(searchFilter) {
      var locationIds = searchFilter.locationIds;
      var locationGroupIds = searchFilter.locationGroupIds;
      var locationFilter = {
        locations: locationIds,
        locationGroups: locationGroupIds,
        selectedSearchFilterId: searchFilter.id,
        queryLocations: _toConsumableArray(new Set([].concat(_toConsumableArray(locationIds), _toConsumableArray(this.getLocationIdsByLocationGroupIds(locationGroupIds)))))
      };
      this.$emit('change-locations', locationFilter);
    },
    showCreateNewSearchFilterModal: function showCreateNewSearchFilterModal() {
      var _QueryService$get,
        _this3 = this;
      var filter = (_QueryService$get = QueryService.get('filter')) === null || _QueryService$get === void 0 ? void 0 : _QueryService$get.location;
      VuedalsBus.$emit('new', {
        title: this.$t('modalTitleNewSearchFilter'),
        name: 'SearchFilterCreateNewSearchFilterModal',
        size: 'sm',
        props: {
          data: {
            name: null,
            locationIds: filter === null || filter === void 0 ? void 0 : filter.locations,
            locationGroupIds: filter === null || filter === void 0 ? void 0 : filter.locationGroups
          }
        },
        closeOnBackdrop: false,
        component: CreateSearchFilterModal,
        onClose: function onClose(param) {
          if ((param === null || param === void 0 ? void 0 : param.refresh) === true) {
            _this3.loadData();
          }
        }
      });
    }
  }
};